//---- components ---------
//---- mixins -------------
//---- services -----------
import customerService from "./../services/advisor-custom.service.js";
//---- other --------------
//---- 3rd-parties --------

export const initialState = {
    gdprData: null,
}

export const advisorCustom = {
    namespaced: true,
    state: { ...initialState },

    actions: {
        getGeoLocalizationInformation({ commit }) {
            return customerService.getGeoLocalizationInformation().then(response => {
                if (response.data) {
                    commit('setGeoLocalizationInfo', response.data)
                }
            })
        }
    },
    mutations: {
        setGeoLocalizationInfo(state, gdprData) {
            state.gdprData = gdprData
        }
    },
    /**---------------------getters ------------------------------------------**/
    getters: {
        isSubjectToGDPR: (state) => {
            //write the logic to verify the country
            return state?.gdprData?.country === "India" 
        },
    },


}